export const displayNewCourseList = (courses) =>{
    return {
        type : "UPDATE COURSE LIST" ,
        payload : courses
    }
}